<template>
  <div class="fillcontain">
    <head-top></head-top>
    <div class="table_container">
      <el-tabs v-model="activeName"  @tab-click="handleClick">
        <el-tab-pane label="基本信息" name="first">
          <el-row class="info_row row" :gutter="10">
            <el-col :span="8">
              <div class="area">
                <p class="areaTop">访客数</p>
                <div class="areaCenter">
                  <p class="title">今日访客数</p>
                  <p class="title">{{visitCount.today}}</p>
                  <p class="title">昨日{{visitCount.yesterday}}</p>
                  <p class="title">周{{visitCount.weekday}}</p>
                  <p class="title">月{{visitCount.month}}</p>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="area">
                <p class="areaTop">新增用户数</p>
                <div class="areaCenter">
                  <p class="title">今日新增用户数</p>
                  <p class="title">{{userCount.today}}</p>
                  <p class="title">昨日{{userCount.yesterday}}</p>
                  <p class="title">周{{userCount.weekday}}</p>
                  <p class="title">月{{userCount.month}}</p>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="area">
                <p class="areaTop">新增会员数</p>
                <div class="areaCenter">
                  <p class="title">今日新增会员数</p>
                  <p class="title">{{memberCount.today}}</p>
                  <p class="title">昨日{{memberCount.yesterday}}</p>
                  <p class="title">周{{memberCount.weekday}}</p>
                  <p class="title">月{{memberCount.month}}</p>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row class="data_row row" :gutter="10">
            <el-col :span="8">
              <div class="area">
                <p class="areaTop">课程浏览数</p>
                <div class="areaCenter">
                  <p class="title">今日课程浏览数</p>
                  <p class="title">{{lookCount.today}}</p>
                  <p class="title">昨日{{lookCount.yesterday}}</p>
                  <p class="title">周{{lookCount.weekday}}</p>
                  <p class="title">月{{lookCount.month}}</p>
                </div>
              </div>
            </el-col>
            <el-col :span="16">
              <div class="area">
                <p class="areaTop">会员学习时长</p>
                <el-row class="row" :gutter="10">
                  <el-col :span="8">
                    <div class="areaCenter-study">
                      <p class="title">昨日学习人数</p>
                      <p class="num">{{studyCount.yesterdayStudyUser}}</p>
                    </div>
                </el-col>
                  <el-col :span="8">
                    <div class="areaCenter-time">
                      <p class="title">昨日总学习时长（分钟）</p>
                      <p class="num" v-if="studyCount.yesterdayTimeCount!=null">{{studyCount.yesterdayTimeCount}}</p>
                      <p class="num" v-if="studyCount.yesterdayTimeCount==null">0</p>
                    </div>
                    <div class="areaCenter">
                      <p class="title">周人均学习时长（分钟）</p>
                      <p class="num" v-if="studyCount.weekdayAvgTime!=null">{{studyCount.weekdayAvgTime}}</p>
                      <p class="num" v-if="studyCount.weekdayAvgTime==null">0</p>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="areaCenter-time">
                      <p class="title">昨日人均学习时长（分钟）</p>
                      <p class="num" v-if="studyCount.yesterdayAvgTime!=null">{{studyCount.yesterdayAvgTime}}</p>
                      <p class="num" v-if="studyCount.yesterdayAvgTime==null">0</p>
                    </div>
                    <div class="areaCenter">
                      <p class="title">月人均学习时长（分钟）</p>
                      <p class="num" v-if="studyCount.monthAvgTime!=null">{{studyCount.monthAvgTime}}</p>
                      <p class="num" v-if="studyCount.monthAvgTime==null">0</p>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
          <el-tabs type="border-card" @tab-click="handleClicks">
            <el-tab-pane label="新增用户数">
              <div id="myChart2" v-show="isShow2"></div>
            </el-tab-pane>
            <el-tab-pane label="新增会员数"><div id="myChart3" v-show="isShow3"></div></el-tab-pane>
            <el-tab-pane label="访客数"><div id="myChart4" v-show="isShow4"></div></el-tab-pane>
            <el-tab-pane label="课程浏览数"><div id="myChart5" v-show="isShow5"></div></el-tab-pane>
            <el-tab-pane :disabled="true">
              <span slot="label">
                时间筛选：
                <el-select v-model="value1" placeholder="请选择" style="width: 200px">
                  <el-option
                    v-for="item in categoryOptions"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id">
                  </el-option>
                </el-select>
                <el-date-picker
                  @change="change1"
                  v-if="value1 == 1"
                  v-model="value2"
                  type="date"
                  :picker-options="pickerOptions0"
                  placeholder="选择日期">
                </el-date-picker>
                <el-date-picker
                  @change="change2"
                  v-if="value1 == 2 || value1 == 3"
                  v-model="value3"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions2">
                </el-date-picker>
              </span>
              我的行程
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>
        <el-tab-pane label="数据总览" name="second">
          <el-row class="over_row row">
            <el-col :span="24">
              <div class="area">
                <p class="areaTop">课程总览</p>
                <div class="area-content">
                  <div class="area-list">
                  <div class="area-list-label">课程总数</div>
                  <ul class="area-list-ul" >
                    <li class="area-list-li">
                      <img src="../assets/v2_pmt2zk.png" class="area-list-img"/>
                      <p class="area-list-titles">{{curriculum.classCount}}</p>
                    </li>
                  </ul>
                </div>
                  <div class="area-list">
                    <div class="area-list-label">试看课程</div>
                    <ul class="area-list-ul" >
                      <li class="area-list-li">
                        <img src="../assets/v2_pmt2zk.png" class="area-list-img"/>
                        <p class="area-list-titles">{{curriculum.createCount}}</p>
                      </li>
                    </ul>
                  </div>
                  <div class="area-list">
                    <div class="area-list-label">如何创作</div>
                    <ul class="area-list-ul" >
                      <li class="area-list-li">
                        <img src="../assets/v2_pmt2zk.png" class="area-list-img"/>
                        <p class="area-list-titles">{{curriculum.videCount}}</p>
                      </li>
                    </ul>
                  </div>
                  <div class="area-list">
                    <div class="area-list-label" >课题大全</div>
                    <ul class="area-list-ul" v-for="(item,index) in curriculum.titleList">
                      <li class="area-list-li">
                        <img src="../assets/v2_pmt2zk.png" class="area-list-img"/>
                        <div class="area-list-li-tit">
                          <p class="area-list-title">{{item.count}}</p>
                          <div class="area-list-label">{{item.name}}</div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="area-list">
                    <div class="area-list-label">单体画法</div>
                    <ul class="area-list-ul" v-for="(item,index) in curriculum.drawList">
                      <li class="area-list-li">
                        <img src="../assets/v2_pmt2zk.png" class="area-list-img"/>
                        <div class="area-list-li-tit">
                          <p class="area-list-title">{{item.count}}</p>
                          <div class="area-list-label">{{item.name}}</div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="area">
                <p class="areaTop">商品总览</p>
                <div class="area-content">
                  <div class="area-list">
                    <div class="area-list-label">商品总类</div>
                    <ul class="area-list-ul" >
                      <li class="area-list-li">
                        <img src="../assets/v2_pmt2zk.png" class="area-list-img"/>
                        <p class="area-list-titles">{{commodity.goodsType}}</p>
                      </li>
                    </ul>
                  </div>
                  <div class="area-list">
                    <div class="area-list-label">分类详情</div>
                    <ul class="area-list-ul" v-for="(item,index) in commodity.typeList">
                      <li class="area-list-li">
                        <img src="../assets/v2_pmt2zk.png" class="area-list-img"/>
                        <div class="area-list-li-tit">
                          <p class="area-list-title">{{item.count}}</p>
                          <div class="area-list-label">{{item.name}}</div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="area">
                <p class="areaTop">素材总览</p>
                <div class="area-content">
                  <div class="area-list">
                    <div class="area-list-label">素材总数</div>
                    <ul class="area-list-ul" >
                      <li class="area-list-li">
                        <img src="../assets/v2_pmt2zk.png" class="area-list-img"/>
                        <p class="area-list-titles">{{material.count}}</p>
                      </li>
                    </ul>
                  </div>
                  <div class="area-list">
                    <div class="area-list-label">排版</div>
                    <ul class="area-list-ul" >
                      <li class="area-list-li">
                        <img src="../assets/v2_pmt2zk.png" class="area-list-img"/>
                        <p class="area-list-titles">{{material.frame}}</p>
                      </li>
                    </ul>
                  </div>
                  <div class="area-list">
                    <div class="area-list-label">边框</div>
                    <ul class="area-list-ul" >
                      <li class="area-list-li">
                        <img src="../assets/v2_pmt2zk.png" class="area-list-img"/>
                        <p class="area-list-titles">{{material.typesetting}}</p>
                      </li>
                    </ul>
                  </div>
                  <div class="area-list">
                    <div class="area-list-label" >图案</div>
                    <ul class="area-list-ul" v-for="(item,index) in material.imagList">
                      <li class="area-list-li">
                        <img src="../assets/v2_pmt2zk.png" class="area-list-img"/>
                        <div class="area-list-li-tit">
                          <p class="area-list-title">{{item.count}}</p>
                          <div class="area-list-label">{{item.name}}</div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="交易概况" name="third">
          <el-row class="role_row row">
            <el-col :span="24">
              <div class="area">
                <p class="areaTop">交易概况</p>
                <div class="areaRight">
                  时间筛选：
                  <el-select v-model="value5" placeholder="请选择" style="width: 200px">
                    <el-option
                      v-for="item in categoryOptions"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id">
                    </el-option>
                  </el-select>
                  <el-date-picker
                    v-if="value5 == 1"
                    v-model="value6"
                    type="date"
                    :picker-options="pickerOptions0"
                    placeholder="选择日期">
                  </el-date-picker>
                  <el-date-picker
                    v-if="value5 == 2 || value5 == 3"
                    v-model="value7"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions2">
                  </el-date-picker>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row class="role_row row">
            <el-col :span="24">
              <div class="areaCoent">
                <div class="areaCoent-list">
                  <div class="areaCoent-list_class">
                    <p class="areaCoent-list_title">访客数(非会员)</p>
                    <p class="areaCoent-list_data">{{survey.visitor}}</p>
                  </div>
                </div>
                <div class="areaCoent-list">
                  <div class="areaCoent-list_class">
                    <p class="areaCoent-list_title">下单买家数量</p>
                    <p class="areaCoent-list_data">{{survey.order}}</p>
                  </div>
                  <div class="areaCoent-list_class">
                    <p class="areaCoent-list_title">下单金额</p>
                    <p class="areaCoent-list_data">{{survey.orderMoney}}</p>
                  </div>
                </div>
                <div class="areaCoent-list">
                  <div class="areaCoent-list_class">
                    <p class="areaCoent-list_title">支付买家数</p>
                    <p class="areaCoent-list_data">{{survey.pay}}</p>
                  </div>
                  <div class="areaCoent-list_class">
                    <p class="areaCoent-list_title">支付金额</p>
                    <p class="areaCoent-list_data">{{survey.payMoney}}</p>
                  </div>
                </div>
              </div>
              <div class="areaCoentPic">
                <img src="../assets/charts.png" class="pic"/>
              </div>
              <div class="order-growth">
              <p class="growth-title"> 访问-下单转化率</p>
              <span class="percentage">{{survey.visitorOrder}}%</span>
            </div>
              <div class="order-pay-growth">
                <p class="growth-title"> 下单-付款转化率</p>
                <span class="percentage">{{survey.orderPay}}%</span>
              </div>
              <div class="pay-growth">
                <p class="growth-title"> 访问-付款转化率</p>
                <span class="percentage">{{survey.visitorPay}}%</span>
              </div>
            </el-col>
          </el-row>
          <el-row class="selc_row row">
            <el-col :span="24">
              <el-select v-model="value8" placeholder="请选择" style="width: 200px">
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="24">
              <div id="myChart1" v-show="isShow"></div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="渠道来源" name="fourth">
          <el-row class="role_row row">
            <el-col :span="24">
              <div class="area">
                <p class="areaTop">渠道来源</p>
                <div class="areaRight">
                  时间筛选：
                  <el-select v-model="value9" placeholder="请选择" style="width: 200px">
                    <el-option
                      v-for="item in categoryOptions"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id">
                    </el-option>
                  </el-select>
                  <el-date-picker
                    v-if="value9 == 1"
                    v-model="value10"
                    type="date"
                    :picker-options="pickerOptions0"
                    placeholder="选择日期">
                  </el-date-picker>
                  <el-date-picker
                    v-if="value9 == 2 || value9 == 3"
                    v-model="value11"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions2">
                  </el-date-picker>
                </div>
              </div>
            </el-col>
            <el-col :span="24">
              <div id="myChart" v-show="isShow6"></div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="排行榜" name="fifth">
          <el-row class="role_row row">
            <el-col :span="24">
              <div class="area">
                <p class="areaTop">课程学习排行榜</p>
                <div class="areaRight">
                  <el-select v-model="value12" placeholder="请选择" style="width: 200px">
                    <el-option
                      v-for="item in options1"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </el-col>
            <el-col :span="24">
              <el-table
                :data="tableData"
                style="width: 100%">
                <el-table-column
                  label="排名"
                  type="index"
                  width="70">
                </el-table-column>
                <el-table-column
                  label="课程名称"
                  prop="courseName">
                </el-table-column>
                <el-table-column
                  label="课程类别">
                  <template slot-scope="scope" >
                    <span v-if="scope.row.category =='1'" >单体画法</span>
                    <span v-if="scope.row.category =='2'" >课题大全</span>
                    <span v-if="scope.row.category =='3'" >如何创作</span>
                    <span v-if="scope.row.category =='41' || scope.row.category =='42' || scope.row.category =='43' || scope.row.category =='44'" >试看课程</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="课程时长"
                  prop="timeLength">
                </el-table-column>
                <el-table-column
                  label="总学习次数"
                  prop="studyCount">
                </el-table-column>
              </el-table>
              <div class="Pagination">
                <el-pagination
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-size="20"
                  layout="total, prev, pager, next"
                  :total="total">
                </el-pagination>
              </div>
            </el-col>

          </el-row>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
  import headTop from '../components/headTop'
  import { getScreening,getTransaction,getLine,getRank,getChannel,getBaseInfo,getSelectLineChart } from "../api/api"
  export default {
    data() {
      return {
        tableData:[],
        curriculum:[],
        commodity:[],
        material:[],
        survey:[],
        data_x:[],
        data_y:[],
        data_x1:[],
        data_y1:[],
        data_x2:[],
        data_y2:[],
        lookCount:[],
        memberCount:[],
        studyCount:[],
        userCount:[],
        visitCount:[],
        activeName: 'first',
        activeName2: 'first',
        isShow:true,
        isShow2:true,
        isShow3:true,
        isShow4:true,
        isShow5:true,
        isShow6:true,
        value:'',
        value1:'1',
        value2:'',
        value3:'',
        value4:'',
        value5:'1',
        value6:new Date(),
        value7:'',
        value8:'1',
        value9:'1',
        value10:new Date(),
        value11:'',
        value12:'1',
        type:'1',
        name:'',
        limit: 20,
        total: 0,
        currentPage: 1,
        categoryOptions:[
          {
            id: '1',
            label: '自然天'
          }, {
            id: '2',
            label: '自然周'
          }, {
            id: '3',
            label: '自然月'
          },
        ],
        options:[
          {
            id: '1',
            label: '访客数'
          }, {
            id: '2',
            label: '下单买家数'
          }, {
            id: '3',
            label: '支付买家数'
          }, {
            id: '4',
            label: '访问-下单转化率'
          }, {
            id: '5',
            label: '下单-付款转化率'
          }, {
            id: '6',
            label: '访问-付款转化率'
          },
        ],
        options1:[
          {
            id: '1',
            label: '排名从高到低'
          }, {
            id: '2',
            label: '排名从低到高'
          }
        ],
        pickerOptions0: {
          disabledDate(time) {
            return time.getTime() > Date.now() - 8.64e6;//如果没有后面的-8.64e6就是不可以选择今天的
          }
        },
        pickerOptions2: {
          disabledDate(time) {
            return time.getTime() > Date.now() - 8.64e6;//如果没有后面的-8.64e6就是不可以选择今天的
          },
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      };
    },
    components: {
      headTop,
    },
    methods: {
      dateFilter(input) {
        let d = new Date(input);
        let year = d.getFullYear();
        let month = d.getMonth() + 1;
        let day = d.getDate() <10 ? '0' + d.getDate() : '' + d.getDate();
        return  year+ '-' + month + '-' + day ;
      },
      dateFilters(input) {
        let d = new Date(input);
        let year = d.getFullYear();
        let month = d.getMonth() + 1;
        let day = d.getDate() <10 ? '0' + d.getDate() : '' + d.getDate();
        let hour = d.getHours();
        let min = d.getMinutes();
        let sec = d.getSeconds();
        return  year+ '-' + month + '-' + day+ ' ' + hour+ ':' +min+ ':' +sec
      },
      handleClick(tab, event) {
        if (tab.name == 'second'){
          getScreening().then(res=>{
            this.curriculum = res.course
            this.commodity = res.goods
            this.material = res.material
          }).catch(error=>{
            console.log(error);
          })
        }else if (tab.name == 'third') {
          this.data_x1 = []
          this.data_y1 = []
          if (this.value5 == 1){
            getTransaction({createTime:this.dateFilter(this.value6)}).then(res=>{
              this.survey = res
            }).catch(error=>{
              console.log(error);
            })
            let params = {
              createTime:this.dateFilter(this.value6),
              endTime:this.dateFilter(this.value6),
              type:this.value8
            }
            getLine(params).then(res=>{
              if (res.length > 0){
                this.isShow = true
                for (let i=0; i<res.length;i++) {
                  this.name = '访客数'
                  this.data_x1.push(this.dateFilter(res[i].time))
                  if (res[i].bigDecimal == null) {
                    this.data_y1.push(0)
                  }else {
                    this.data_y1.push(res[i].bigDecimal)
                  }
                  this.drawLine()
                }
              }else {
                this.isShow = false
                this.$message({
                  type: 'error',
                  message: '暂无数据'
                });
              }
            }).catch(error=>{
              console.log(error);
            })
          }else {
            getTransaction({createTime:this.dateFilter(this.value7[0]),endTime:this.dateFilter(this.value7[1])}).then(res=>{
              this.survey = res
            }).catch(error=>{
              console.log(error);
            })
            let params = {
              createTime:this.dateFilter(this.value7[0]),
              endTime:this.dateFilter(this.value7[1]),
              type:this.value8
            }
            getLine(params).then(res=>{
              if (res.length > 0){
                this.isShow = true
                for (let i=0; i<res.length;i++) {
                  this.name = '访客数'
                  this.data_x1.push(this.dateFilter(res[i].time))
                  if (res[i].bigDecimal == null) {
                    this.data_y1.push(0)
                  }else {
                    this.data_y1.push(res[i].bigDecimal)
                  }
                  this.drawLine()
                }
              }else {
                this.isShow = false
                this.$message({
                  type: 'error',
                  message: '暂无数据'
                });
              }
            }).catch(error=>{
              console.log(error);
            })
          }

        }else if (tab.name == 'fourth') {
          this.data_x = []
          this.data_y = []
          if (this.value9 == 1){
            let params = {
              createTime:this.dateFilter(this.value10),
              endTime:this.dateFilter(this.value10)
            }
            getChannel(params).then(res=> {
              if (res.length > 0) {
                this.isShow6 = true
                for (let i = 0; i < res.length; i++) {
                  this.data_x.push(res[i].source)
                  if (res[i].count == null){
                    this.data_y.push(0)
                  } else {
                    this.data_y.push(res[i].count)
                  }
                  this.drawBar()
                }
              }else {
                this.isShow6 = false
                this.$message({
                  type: 'error',
                  message: '暂无数据'
                });
              }
            })
          } else {
            let params = {
              createTime:this.dateFilter(this.value11[0]),
              endTime:this.dateFilter(this.value11[1])
            }
            getChannel(params).then(res=> {
              if (res.length > 0) {
                this.isShow6 = true
                for (let i = 0; i < res.length; i++) {
                  this.data_x.push(res[i].source)
                  if (res[i].count == null){
                    this.data_y.push(0)
                  } else {
                    this.data_y.push(res[i].count)
                  }
                  this.drawBar()
                }
              }else {
                this.isShow6 = false
                this.$message({
                  type: 'error',
                  message: '暂无数据'
                });
              }
            })
          }


        }else if (tab.name == 'fifth') {
          this.getRank()
        }
      },
      handleClicks(tab, event){
        if (tab.label == '新增用户数'){
          this.type = 1
          if (this.value1 ==1 ){
            this.change1()
          } else {
            this.change2()
          }
        }else if(tab.label == '新增会员数'){
          this.type = 2
          if (this.value1 ==1 ){
            this.change1()
          } else {
            this.change2()
          }
        }else if(tab.label == '访客数'){
          this.type = 3
          if (this.value1 ==1 ){
            this.change1()
          } else {
            this.change2()
          }
        }else if(tab.label == '课程浏览数'){
          this.type = 4
          if (this.value1 ==1 ){
            this.change1()
          } else {
            this.change2()
          }
        }
      },
      getBaseInfo(){
        getBaseInfo().then(res=>{
          this.memberCount = res.memberCount
          this.lookCount = res.lookCount
          this.studyCount = res.studyCount
          this.userCount = res.userCount
          this.visitCount = res.visitCount
          this.value2 = this.dateFilters(new Date(new Date()-24*60*60*1000))
          for (let i=0; i<res.userLineChart.length;i++) {
            this.data_y2.push(this.dateFilters(res.userLineChart[i].time))
            this.data_x2.push(res.userLineChart[i].count)
            this.drawLines()
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      change1(){
        this.data_x2 = []
        this.data_y2 = []
        let params = {
          createTime:this.dateFilter(this.value2),
          endTime:this.dateFilter(this.value2),
          type:this.type
        }
        getSelectLineChart(params).then(res=>{
          if (res.length > 0){
            for (let i=0; i<res.length;i++) {
              this.data_y2.push(this.dateFilter(res[i].time))
              if (res[i].count == null){
                this.data_x2.push(0)
              } else {
                this.data_x2.push(res[i].count)
              }
              if (this.type == 1){
                this.drawLines()
              } else if(this.type == 2){
                this.drawLines1()
              }else if(this.type == 3){
                this.drawLines2()
              }else if(this.type == 4){
                this.drawLines3()
              }
            }
          }else {
            if (this.type == 1){
              this.isShow2 = !this.isShow2
            } else if(this.type == 2){
              this.isShow3 = !this.isShow3
            }else if(this.type == 3){
              this.isShow4 = !this.isShow4
            }else if(this.type == 4){
              this.isShow5 = !this.isShow5
            }

            this.$message({
              type: 'error',
              message: '暂无数据'
            });
            return
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      change2(){
        this.data_x2 = []
        this.data_y2 = []
        let params = {
          createTime:this.dateFilter(this.value3[0]),
          endTime:this.dateFilter(this.value3[1]),
          type:this.type
        }
        getSelectLineChart(params).then(res=>{
          if (res.length > 0){
            for (let i=0; i<res.length;i++) {
              this.data_y2.push(this.dateFilter(res[i].time))
              if (res[i].count == null){
                this.data_x2.push(0)
              } else {
                this.data_x2.push(res[i].count)
              }
              if (this.type == 1){
                this.drawLines()
              } else if(this.type == 2){
                this.drawLines1()
              }else if(this.type == 3){
                this.drawLines2()
              }else if(this.type == 4){
                this.drawLines3()
              }
            }
          }else {
            if (this.type == 1){
              this.isShow2 = !this.isShow2
            } else if(this.type == 2){
              this.isShow3 = !this.isShow3
            }else if(this.type == 3){
              this.isShow4 = !this.isShow4
            }else if(this.type == 4){
              this.isShow5 = !this.isShow5
            }
            this.$message({
              type: 'error',
              message: '暂无数据'
            });
            return
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      getSelectLineChart(){
        let params = {
          createTime:this.dateFilter(new Date()),
          endTime:this.dateFilter(new Date()),
          type:this.type
        }
        getSelectLineChart(params).then(res=>{
          for (let i=0; i<res.userLineChart.length;i++) {
            this.data_x2.push(res.userLineChart[i].time)
            if (res[i].count == null){
              this.data_y2.push(0)
            } else {
              this.data_y2.push(res.userLineChart[i].count)
            }
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      //排行榜列表
      getRank(){
        let params = {
          sort:this.value12,
          pageSize:this.limit,
          pageNum:this.currentPage
        }
        getRank(params).then(res=>{
          this.tableData = res.pageInfo
          this.total = res.total
        }).catch(error=>{
          console.log(error);
        })
      },
      //排行榜页码
      handleCurrentChange (val) {
        this.currentPage = val;
        this.getRank()
      },
      drawBar(){
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChart'))
        // 绘制图表
        myChart.setOption({
          tooltip: {},
          xAxis: {
            data:  this.data_x
          },
          yAxis: {},
          series: [{
            name: '来源',
            type: 'bar',
            barWidth: '10%',
            data: this.data_y
          }]
        });
      },
      drawLines(){
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChart2'))
        // 绘制图表
        myChart.setOption({
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.data_y2
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              type:'line',
              stack: '总量',
              data:this.data_x2
            },
          ]
        });
      },
      drawLines1(){
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChart3'))
        // 绘制图表
        myChart.setOption({
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.data_y2
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              type:'line',
              stack: '总量',
              data:this.data_x2
            },
          ]
        });
      },
      drawLines2(){
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChart4'))
        // 绘制图表
        myChart.setOption({
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.data_y2
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              type:'line',
              stack: '总量',
              data:this.data_x2
            },
          ]
        });
      },
      drawLines3(){
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChart5'))
        // 绘制图表
        myChart.setOption({
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.data_y2
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              type:'line',
              stack: '总量',
              data:this.data_x2
            },
          ]
        });
      },
      drawLine(){
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChart1'))
        // 绘制图表
        myChart.setOption({
          tooltip : {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow',
              label: {
                show: true
              }
            }
          },
          calculable : true,
          grid: {
            top: '12%',
            left: '1%',
            right: '10%',
            containLabel: true
          },
          xAxis: [
            {
              type : 'category',
              data : this.data_x1
            }
          ],
          yAxis: [
            {
              type : 'value',
            }
          ],
          dataZoom: [
            {
              show: true,
              start: 0,
              end: 100
            },
            {
              type: 'inside',
              start: 94,
              end: 100
            },
            {
              show: true,
              yAxisIndex: 0,
              filterMode: 'empty',
              width: 30,
              height: '80%',
              showDataShadow: false,
              left: '93%'
            }
          ],
          series : [
            {
              name:this.name,
              type: 'line',
              data: this.data_y1
            }
          ]
        });
      }
    },
    created (){
      this.getBaseInfo()
    },
    watch:{
      //交易概况自然天监听
      value6(val, oldVal){
        this.data_x1=[]
        this.data_y1=[]
        this.value8 = '1'
        let params = {
          createTime:this.dateFilter(val)
        }
        getTransaction(params).then(res=>{
          this.survey = res
        }).catch(error=>{
          console.log(error);
        })
        getLine({ createTime:this.dateFilter(val),
          endTime:this.dateFilter(val),
          type:this.value8}).then(res=>{
          if (res.length > 0){
            this.isShow = true
            for (let i=0; i<res.length;i++) {
              this.name = '访客数'
              this.data_x1.push(this.dateFilter(res[i].time))
              if (res[i].bigDecimal == null) {
                this.data_y1.push(0)
              }else {
                this.data_y1.push(res[i].bigDecimal)
              }
              this.drawLine()
            }
          }else {
            this.isShow = false
            this.$message({
              type: 'error',
              message: '暂无数据'
            });
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      //交易概况自然周月监听
      value7(val, oldVal){
        this.data_x1=[]
        this.data_y1=[]
        this.value8 = '1'
        let params = {
          createTime:this.dateFilter(val[0]),
          endTime:this.dateFilter(val[1])
        }
        getTransaction(params).then(res=>{
          this.survey = res
        }).catch(error=>{
          console.log(error);
        })
        getLine({ createTime:this.dateFilter(val[0]),
          endTime:this.dateFilter(val[1]),
          type:this.value8}).then(res=>{
          if (res.length > 0){
            this.isShow = true
            for (let i=0; i<res.length;i++) {
              this.name = '访客数'
              this.data_x1.push(this.dateFilter(res[i].time))
              if (res[i].bigDecimal == null) {
                this.data_y1.push(0)
              }else {
                this.data_y1.push(res[i].bigDecimal)
              }
              this.drawLine()
            }
          }else {
            this.isShow = false
            this.$message({
              type: 'error',
              message: '暂无数据'
            });
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      //交易概况折线图数据监听
      value8(val, oldVal){
        if (this.value5 == 1){
          let params = {
            createTime:this.dateFilter(this.value6),
            endTime:this.dateFilter(this.value6),
            type:val
          }
          getLine(params).then(res=>{
            if (res.length > 0){
              this.isShow = true
              this.data_x1 = []
              this.data_y1 = []
              if (val == 1){
                this.name = '访客数'
              } else if(val == 2){
                this.name = '下单买家数'
              }else if(val == 3){
                this.name = '支付买家数'
              }else if(val == 4){
                this.name = '访问-下单转化率'
              }else if(val == 5){
                this.name = '下单-付款转化率'
              }else if(val == 6){
                this.name = '访问-付款转化率'
              }
              for (let i=0; i<res.length;i++) {
                this.data_x1.push(this.dateFilter(res[i].time))
                if (res[i].bigDecimal == null) {
                  this.data_y1.push(0)
                }else {
                  this.data_y1.push(res[i].bigDecimal)
                }
                this.drawLine()
              }
            } else {
              this.isShow = false
              this.$message({
                type: 'error',
                message: '暂无数据'
              });
            }
          }).catch(error=>{
            console.log(error);
          })
        }else {
          let params = {
            createTime:this.dateFilter(this.value7[0]),
            endTime:this.dateFilter(this.value7[1]),
            type:val
          }
          getLine(params).then(res=>{
            if (res.length > 0){
              this.data_x1 = []
              this.data_y1 = []
              if (val == 1){
                this.name = '访客数'
              } else if(val == 2){
                this.name = '下单买家数'
              }else if(val == 3){
                this.name = '支付买家数'
              }else if(val == 4){
                this.name = '访问-下单转化率'
              }else if(val == 5){
                this.name = '下单-付款转化率'
              }else if(val == 6){
                this.name = '访问-付款转化率'
              }
              for (let i=0; i<res.length;i++) {
                this.data_x1.push(this.dateFilter(res[i].time))
                if (res[i].bigDecimal == null) {
                  this.data_y1.push(0)
                }else {
                  this.data_y1.push(res[i].bigDecimal)
                }
                this.drawLine()
              }
            } else {
              this.$message({
                type: 'error',
                message: '暂无数据'
              });
              return
            }
          }).catch(error=>{
            console.log(error);
          })
        }
      },
      //渠道来源自然天监听
      value10(val, oldVal){
        let params = {
          createTime:this.dateFilter(val),
          endTime:this.dateFilter(val)
        }
        getChannel(params).then(res=>{
          this.data_x = []
          this.data_y = []
          if (res.length > 0) {
            this.isShow6 = true
            for (let i = 0; i < res.length; i++) {
              this.data_x.push(res[i].source)
              if (res[i].count == null){
                this.data_y.push(0)
              } else {
                this.data_y.push(res[i].count)
              }
              this.drawBar()
            }
          }else {
            this.isShow6 = false
            this.$message({
              type: 'error',
              message: '暂无数据'
            });
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      //渠道来源柱状图监听
      value11(val, oldVal){
        let params = {
          createTime:this.dateFilter(val[0]),
          endTime:this.dateFilter(val[1])
        }
        getChannel(params).then(res=>{
          this.data_x = []
          this.data_y = []
          if (res.length > 0) {
            this.isShow6 = true
            for (let i = 0; i < res.length; i++) {
              this.data_x.push(res[i].source)
              if (res[i].count == null){
                this.data_y.push(0)
              } else {
                this.data_y.push(res[i].count)
              }
              this.drawBar()
            }
          }else {
            this.isShow6 = false
            this.$message({
              type: 'error',
              message: '暂无数据'
            });
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      value12(val, oldVal){//普通的watch监听
        this.getRank()
      },
    }
  }
</script>

<style lang="less">
  .info_row{
    margin-bottom: 20px;
    .area{
      -moz-box-shadow:2px 2px 2px #eeeeee;
      -webkit-box-shadow:2px 2px 25px #eeeeee;
      box-shadow:2px 2px 2px #eeeeee;
      border:1px solid #dfdfdf;
      overflow:hidden;
      .areaTop{
        width: 100%;
        font-size: 14px;
        line-height: 40px;
        padding-left: 15px;
        background: #f9f9f9;
      }
      .areaCenter{
        text-align:center;
        padding:10px;
        .title {
          font-size: 14px;
          line-height: 24px;
          font-weight: 700;
        }
      }
    }
  }
  .data_row{
    .area{
      border:1px solid #dfdfdf;
      -moz-box-shadow:2px 2px 2px #eeeeee;
      -webkit-box-shadow:2px 2px 2px #eeeeee;
      box-shadow:2px 2px 2px #eeeeee;
      overflow:hidden;
      margin-bottom: 20px;
      .areaTop{
        width: 100%;
        font-size: 14px;
        line-height: 40px;
        padding-left: 15px;
        background: #f9f9f9;
      }
      .areaCenter{
        text-align:center;
        padding:10px;
        .title {
          font-size: 14px;
          line-height: 24px;
          font-weight: 700;
        }
      }
      .areaCenter-study{
         border-right:1px solid #eeeeee;
         text-align:center;
         padding:47.5px;
         .title {
           font-size: 14px;
           line-height: 24px;
           font-weight: 700;
         }
       }
      .areaCenter-time{
        margin-top: 15px;
        border-bottom:1px solid #eeeeee;
        text-align:center;
        padding:7px;
        .title {
          font-size: 14px;
          line-height: 24px;
          font-weight: 700;
        }
      }
    }
  }
  #myChart2{
    width: 80vw;
    height: 600px;
  }
  #myChart3{
    width: 80vw;
    height: 600px;
  }
  #myChart4{
    width: 80vw;
    height: 600px;
  }
  #myChart5{
    width: 80vw;
    height: 600px;
  }
  .el-tabs__nav{
    width: 100%;
    .is-disabled{
      float: right;
    }
  }
  .over_row{
    .area{
      overflow:hidden;
      .areaTop {
        overflow: hidden;
        background: #F8F8F8;
        padding: 9px 10px;
      }
      .area-content{
          margin-top: 10px;
          .area-list{
            display: flex;
            display: -webkit-flex;
            flex-direction: row;
            padding: 20px;
            .area-list-label {
              order: 1;
              font-size: 14px;
              line-height: 24px;
              color: #353535;
              margin-right: 40px;
              min-width: 66px;
            }
            .area-list-ul{
                display: flex;
                display: -webkit-flex;
                flex-direction: row;
                order: 2;
                padding: 0;
                .area-list-li{
                  display: flex;
                  display: -webkit-flex;
                  flex-direction: row;
                  width: 190px;
                  .area-list-img {
                    width: 48px;
                    height: 48px;
                    margin-right: 10px;
                  }
                  .area-list-titles{
                    color: #353535;
                    font: 14px/48px "";
                  }
                  .area-list-li-tit{
                    .area-list-title{
                      color: #353535;
                      font-size: 14px;
                      line-height: 24px;
                    }
                  }
                }
              }
          }

        }
    }
  }
  .role_row{
    margin-bottom: 20px;
    .area{
      background: #F8F8F8;
      overflow:hidden;
      .areaTop {
        padding: 20px 10px;
        float: left;
      }
      .areaRight{
        padding: 14px 10px;
        float: right;
      }
    }
    .areaCoent{
      .areaCoent-list{
        height: 80px;
        background: rgba(42, 117, 237, 0.06);
        .areaCoent-list_class{
          float: left;
          min-width: 188px;
          padding: 16px 0 16px 40px;
          .areaCoent-list_title{
            position: relative;
            font-size: 12px;
            color: #666666;
            line-height: 20px;
            .areaCoent-list_data{
              line-height: 22px;
              white-space: nowrap;
            }
          }
        }
      }
    }
    .areaCoentPic{
      position: absolute;
      right: 60px;
      top: 0;
      height: 100%;
      width: 460px;
      .pic{
        position: absolute;
        top: 0;
        right: 20px;
        bottom: 0;
        height: 240px;
        background-size: 100% 100%;
        width: 100%;
        z-index: 999;
      }
    }
    .order-growth{
      position: absolute;
      top: 76px;
      right: 110px;
      z-index: 999;
      .growth-title{
        color: #666666;
        line-height: 20px;
        .percentage{
          margin-top: 15px;
          font-size: 14px;
          line-height: 22px;
          color: #353535;
        }
      }
    }
    .order-pay-growth{
      position: absolute;
      top: 158px;
      right: 136px;
      z-index: 999;
      .growth-title{
        color: #666666;
        line-height: 20px;
        .percentage{
          margin-top: 15px;
          font-size: 14px;
          line-height: 22px;
          color: #353535;
        }
      }
    }
    .pay-growth{
      position: absolute;
      top: 176px;
      right: 12px;
      z-index: 999;
      .growth-title{
        color: #666666;
        line-height: 20px;
        .percentage{
          margin-top: 15px;
          font-size: 14px;
          line-height: 22px;
          color: #353535;
        }
      }
    }
    #myChart{
      width: 80vw;
      height: 600px;
    }
  }
  .selc_row{
    margin-bottom: 20px;
    background: #F8F8F8;
    padding: 20px 10px ;
    #myChart1{
      width: 80vw;
      height: 600px;
    }
  }
  .el-tabs__item{
    padding: 0 10px;
  }
</style>




// WEBPACK FOOTER //
// src/page/dataCenter.vue